import { UnitType } from "types/app";
import { formatNumber } from "./formatNumber";

export const formatSpeed = (
  metersPerSecond: number,
  unitType: UnitType,
  decimals: number
) => {
  const unitName = unitType === "metric" ? "km/h" : "mph";
  const speed =
    unitType === "metric"
      ? metersPerSecond * 3.6
      : metersPerSecond * 2.23693629;
  return `${formatNumber(speed, decimals)} ${unitName}`;
};
